import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70de6b29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-pdo-bin-list" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "cell" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = {
  key: 0,
  class: "qrcode"
}
const _hoisted_12 = ["src"]

import { onMounted } from 'vue';
  import { mineBreadcurmbStore, Collection } from '@/stores';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';
  import { request } from '@/utils';
  import { ColorVariants } from '@/constants';
  import download from 'downloadjs';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();

  const store = Collection.create<Collection>({
    fetch(params = {}) {
      const body = {
        ...params,
        target_type_eq: 'PDO',
        target_id_eq: route.params.id
      };
      return request.get('/mine/collection_bins', { params: body });
    }
  });

  function handlePageChange(page: number) {
    store.params.page = page;
    store.fetchData();
  }

  onMounted(async () => {
    await store.fetchData();
    mineBreadcurmbStore.update([
      { name: t('PDO Dashboard'), to: { name: 'pdo.programs' } },
      { name: String(route.query.title), to: { name: 'pdo.program', params: { id: route.params.id } } },
      { name: t('Collection Bin Management') }
    ]);
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)('Collection Bin Management')), 1),
      _createVNode(_component_router_link, {
        class: "new-button",
        to: { name: 'pdo.bin-new', params: _unref(route).params, query: _unref(route).query }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('Create Bin')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "item-card"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('Bin Name')), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('Created at')), 1),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_AppTimeFormat, {
                time: item.created_at,
                format: "YYYY-MM-DD HH:mm:ss"
              }, null, 8, ["time"])
            ])
          ]),
          (item.target?.collection_method === 'user_registration')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("img", {
                  class: "image",
                  src: item.qrcode?.url,
                  crossorigin: "anonymous"
                }, null, 8, _hoisted_12),
                _createVNode(_component_b_button, {
                  class: "down-btn",
                  pill: "",
                  variant: _unref(ColorVariants).primary,
                  onClick: ($event: any) => (_unref(download)(item.qrcode.url))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('Download')), 1)
                  ]),
                  _: 2
                }, 1032, ["variant", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (_unref(store).isEmpty)
      ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(store).meta.total_pages > 1)
      ? (_openBlock(), _createBlock(_component_AppPagination, {
          key: 1,
          total: _unref(store).meta.total,
          "per-page": _unref(store).meta.per_page,
          page: _unref(store).meta.page,
          onChange: handlePageChange
        }, null, 8, ["total", "per-page", "page"]))
      : _createCommentVNode("", true)
  ]))
}
}

})